import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight } from "@snapchat/snap-design-system";

export const marginBottom = css`
    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const checkmark = css`
    cursor: pointer;
    margin-left: 7px;
`;

export const ContainerNameHeader = styled.div`
    font-size: ${FontSizeInPx.REGULAR}px;
    font-weight: ${FontWeight.NORMAL};
    line-height: 20px;
    color: ${Colors.Black.V50};
`;
